import { AnalysisSectionProps } from "./AnalysisSection.types"
import "./AnalysisSection.css"

const AnalysisSection = (props: AnalysisSectionProps) => {

  const { title, titleChild, children } = props

  return (
    <div className="analysis-section-component-container">
      <div className="analysis-section-header">
        <div></div>
        <h3 className="analysis-title">{title}</h3>
        <div className="analysis-section-title-child">
          {titleChild}
        </div>
      </div>
      <div className="analysis-section-container">
        {children}
      </div>
    </div>
  )
}

export default AnalysisSection